module.exports = __webpack_public_path__ + "assets/img/561d-fo.svg";